import { render, staticRenderFns } from "./ServerPaginationComponent.vue?vue&type=template&id=5c205aca&scoped=true"
import script from "./ServerPaginationComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServerPaginationComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ServerPaginationComponent.vue?vue&type=style&index=0&id=5c205aca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c205aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c205aca')) {
      api.createRecord('5c205aca', component.options)
    } else {
      api.reload('5c205aca', component.options)
    }
    module.hot.accept("./ServerPaginationComponent.vue?vue&type=template&id=5c205aca&scoped=true", function () {
      api.rerender('5c205aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pagination/ServerPaginationComponent.vue"
export default component.exports